// HYPE — el buscador busca en el NOMBRE del producto: sin esto Shopify suma «relacionados» y lo que
// solo nombra la palabra en la descripción («samba»: 491 resultados, 10 eran Samba). Orden:
//   1. title:"samba"            → cada palabra en el nombre
//   2. "camiseta" "negra"       → si por nombre no hay nada: nombre o descripción (colores, referencias)
//   3. «samb» o «sambaa»        → se completa/corrige con las palabras de los nombres que sugiere Shopify y vuelve a 1
//   4. lo escrito, tal cual     → solo si nada de lo anterior encontró productos
// Si ya trae comillas, dos puntos, paréntesis o asterisco, se respeta como la escribieron.
(function () {
  const esEspecial = texto => /["“”:()*]/.test(texto);
  const normalizar = texto => (texto || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const porNombre = palabras => palabras.map(palabra => `title:"${palabra}"`).join(' ');
  const exacta = palabras => palabras.map(palabra => `"${palabra}"`).join(' ');
  const pedidos = new Map();

  const productosSugeridos = (consulta, limite = 1) => {
    const clave = `${limite}|${consulta}`;
    if (!pedidos.has(clave)) {
      pedidos.set(clave, fetch(`${Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(consulta)}&resources[type]=product&resources[limit]=${limite}`)
        .then(response => (response.ok ? response.json() : null))
        .then(json => json?.resources?.results?.products || [])
        .catch(() => []));
    }
    return pedidos.get(clave);
  };

  const distancia = (a, b) => {
    const fila = Array.from({ length: b.length + 1 }, (_, j) => j);
    for (let i = 1; i <= a.length; i++) {
      let diagonal = fila[0];
      fila[0] = i;
      for (let j = 1; j <= b.length; j++) {
        const arriba = fila[j];
        fila[j] = Math.min(fila[j] + 1, fila[j - 1] + 1, diagonal + (a[i - 1] === b[j - 1] ? 0 : 1));
        diagonal = arriba;
      }
    }
    return fila[b.length];
  };

  // palabra a medias («samb» → samba) o con una o dos letras de más o de menos («sambaa», «jordn»)
  const completarPalabras = async (texto, palabras) => {
    const conteo = new Map();
    (await productosSugeridos(texto, 10)).forEach(producto => {
      normalizar(producto.title).split(/[^a-z0-9.]+/).forEach(palabra => {
        if (palabra) conteo.set(palabra, (conteo.get(palabra) || 0) + 1);
      });
    });
    return palabras.map(palabra => {
      const inicio = normalizar(palabra);
      if (conteo.has(inicio)) return palabra;
      let mejor = null;
      conteo.forEach((veces, candidata) => {
        if (candidata.startsWith(inicio) && (!mejor || veces > conteo.get(mejor))) mejor = candidata;
      });
      if (!mejor && inicio.length >= 4) {
        const tope = inicio.length >= 7 ? 2 : 1;
        let menor = tope + 1;
        conteo.forEach((veces, candidata) => {
          const d = distancia(inicio, candidata);
          if (d < menor || (d === menor && mejor && veces > conteo.get(mejor))) { menor = d; mejor = candidata; }
        });
        if (menor > tope) mejor = null;
      }
      return mejor || palabra;
    });
  };

  window.hypeEsConsultaEspecial = esEspecial;

  window.hypeMejorConsulta = async function (texto) {
    const term = (texto || '').trim();
    if (!term || esEspecial(term)) return term;

    const palabras = term.split(/\s+/);
    if ((await productosSugeridos(porNombre(palabras))).length) return porNombre(palabras);
    if ((await productosSugeridos(exacta(palabras))).length) return exacta(palabras);

    const completas = await completarPalabras(term, palabras);
    const cambio = completas.some((palabra, i) => palabra !== palabras[i]);
    if (cambio && (await productosSugeridos(porNombre(completas))).length) return porNombre(completas);

    return term;
  };
})();

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });

      // HYPE — Enter y «Ver resultados» van a la mejor búsqueda: /search?q=title:"samba" (sin el relleno)
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', async e => {
        const term = this.input.value.trim();
        if (!term || hypeEsConsultaEspecial(term)) return;

        e.preventDefault();
        const consulta = await hypeMejorConsulta(term);
        const params = new URLSearchParams(new FormData(this.form));
        params.set('q', consulta);
        // ya se probó todo: que la página de resultados no lo vuelva a intentar
        if (consulta === term) params.set('normal', '1');
        window.location.href = `${this.form.getAttribute('action')}?${params.toString()}`;
      });
    }

    // HYPE — sin page ni article: el buscador es para productos (ella, 24-oct); pedirlos aquí le ganaba al ajuste de Search & Discovery
    async fetchSuggestMarkup(searchTerm) {
      const response = await fetch(
        `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection,query&resources[limit]=8&section_id=predictive-search`
      );

      if (!response.ok) {
        throw new Error(response.status);
      }

      const text = await response.text();
      return new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-predictive-search');
    }

    async getSearchResults(searchTerm) {
      // HYPE — un turno por pedido: si llegan desordenadas, solo pinta la de lo último que se escribió
      const turn = (this.searchTurn = (this.searchTurn || 0) + 1);

      try {
        // HYPE — la misma búsqueda que dará Enter (por nombre, completando la palabra a medias)
        const results = await this.fetchSuggestMarkup(await hypeMejorConsulta(searchTerm));

        if (!this.isOpen || turn !== this.searchTurn) {
          return;
        }

        const resultsMarkup = results.innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
